export default "__VITE_ASSET__CwZYLxtT__"